// extracted by mini-css-extract-plugin
export default {"wrap":"SponsoredPlaces_wrap__uUcGz","label":"SponsoredPlaces_label__JFJcA","rows":"SponsoredPlaces_rows__Rhax0"};